<template>
  <div class="message-container">
    <emoji-message-template
      ref="textForm"
      v-model="form.message"
      :component-message="form.message"
      :max="640"
      :rules="'required|max:640'"
      show-max
    />
    <buttons-input
      ref="form"
      v-model="form.buttons"
      :component-buttons="form.buttons"
      :is-facebook="!isInstagram"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EmojiMessageTemplate from '@/@bya3/components/inputs/EmojiMessageTemplate'
import ButtonsInput from '@/@bya3/components/inputs/ButtonsInput'
import ReplyMixin from '../../mixins/reply-mixin'

export default {
  name: 'ButtonsTemplate',
  components: { ButtonsInput, EmojiMessageTemplate },
  mixins: [ReplyMixin],
  computed: {
    ...mapGetters({
      isInstagram: 'auth/isInstagram',
    }),
  },
  mounted() {
    if (!this.form.buttons.length) {
      this.form.buttons.push({
        title: '',
        type: 'web_url',
        payload: '',
      })
    }
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    async submit() {
      let textValid = true
      let buttonsValid = true
      if (this.$refs.textForm?.$refs?.form) {
        textValid = await this.$refs.textForm.$refs.form.validate()
      }
      if (this.$refs.form?.$refs?.form) {
        buttonsValid = await this.$refs.form.$refs.form.validate()
      }
      if (!textValid || !buttonsValid) throw new Error(this.$tc('errors.field-invalid', 1))
    },
  },
}
</script>
